<template>
  <fragment>
    <t-router-link :color="color" to="/cursos" v-if="$config.featureFlags['EXIBIR_MENU_CURSOS']">
      <span v-html="$config.strings['header-btn-1']"  />
    </t-router-link>
    <t-router-link :color="color" to="/regulamento" v-if="$config.featureFlags['EXIBIR_MENU_REGULAMENTO']">
      <span v-html="$config.strings['header-btn-2']"  />
    </t-router-link>
    <t-router-link :color="color" to="/ganhadores" v-if="$config.featureFlags['EXIBIR_MENU_GANHADORES']">
      <span v-html="$config.strings['header-btn-3']"  />
    </t-router-link>
    <t-router-link :color="color" to="/contato" v-if="$config.featureFlags['EXIBIR_MENU_CONTATO']">
      <span v-html="$config.strings['header-btn-4']"  />
    </t-router-link>
    <t-router-link :color="color" to="/numero-da-sorte" v-if="$config.featureFlags['EXIBIR_MENU_NUMEROSORTE']">
      <span v-html="$config.strings['header-btn-5']" />
    </t-router-link>
  </fragment>
</template>

<script>
import { TRouterLink } from '@/components/base'

export default {
  name: 'routes',
  components: { TRouterLink },
  props: { color: String, highlightColor: String }
}
</script>

<style lang="scss" scoped></style>
